
import { defineComponent, onMounted } from 'vue';
import { AppCard, AppTable, AppButton, AppSelect, AppFormRow } from '@/components';
import { useRfmSegmentation } from '@/modules/rfm/segmentation/edit';
import { ROUTE_NAME_RFM } from '@/modules/rfm/router';
import { componentColumn, TableColumn, TableColumnType } from '@/components/table/types';
import { color } from '@/common/utils/helpers';

export default defineComponent({
    name: ROUTE_NAME_RFM.SEGMENTATION,
    components: { AppTable, AppButton, AppSelect, AppFormRow, AppCard },
    setup() {
        const { beforeFetch, fetch, model, query, rfmGroupOptions, renderValueRange, actions } = useRfmSegmentation();

        const columns: TableColumn[] = [
            { type: TableColumnType.Index, label: '#' },
            {
                type: TableColumnType.Html,
                label: 'Recency',
                tooltip: 'How long does account take from last payment? (day)',
                htmlHandler: (row: any) => renderValueRange(row.fromDay, row?.toDay ?? -1)
            },
            {
                type: TableColumnType.Html,
                label: 'Frequence',
                tooltip: 'How many times has account purchased?',
                htmlHandler: (row: any) => renderValueRange(row.fromTransaction, row?.toTransaction ?? -1)
            },
            {
                type: TableColumnType.Html,
                label: 'Monetary',
                tooltip: 'How much did account spend?',
                htmlHandler: (row: any) => renderValueRange(row.fromPayment, row?.toPayment ?? -1)
            },
            componentColumn()({
                label: 'Persona',
                tooltip: 'What kind of persona does account belong to?',
                columnStyles: (row: any) => ({ background: `${color(row.personaId)}` }),
                component: AppSelect,
                propsHandler: (row: any) => ({
                    options: model.personasByGroup,
                    modelValue: row.personaId,
                    onChange: value => {
                        const selectedItem = model.data.find(item => item.index === row.index);
                        selectedItem.personaId = Number(value);
                        actions.changePersona(selectedItem);
                    }
                })
            })
        ];

        onMounted(async () => {
            await beforeFetch();
            await fetch();
        });

        return { columns, fetch, model, query, rfmGroupOptions, actions };
    }
});
